import Colors from '@polestar/component-warehouse-react/tokens/colors/Colors';
const BarChartTheme = {
    barChart: {
        light: {
            defaultBarColor: Colors.signalWhite,
        },
        dark: {
            defaultBarColor: Colors.ironGrey,
        },
    },
};
export default BarChartTheme;
